import { halfPageManagerRowExtender as rowExtender } from './halfPageManagerRowExtender';
import { halfPageManagerInitTopAd as initTopAd } from './halfPageManagerInitTopAd';
import { halfPageManagerInitRepeaters as initRepeaters } from './halfPageManagerInitRepeaters';

const HalfPageManager = (): void => {
  // Prodloužení postranních řádků, aby byly dynamicky dlouhé
  rowExtender();

  // Inicializace top reklamy
  initTopAd();

  // Inicializace repeater reklamy
  initRepeaters();
};

export default HalfPageManager;
